export default __webpack_public_path__ + "static/media/video.13fd1d81.mp4";